/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import axios from 'axios';
import { arrayMerge } from 'flaivy-react/utils/array-helper';
import _ from 'lodash';
import getAxiosInstance from '../../../config/api';
import datalayer from '../../../datalayer';

export const ACTION_TYPES = {
  MAKE_ALL_BATCHES_ALWAYS_ORDERABLE_ARTICLE:
    'ARTICLE/MAKE_ALL_BATCHES_ALWAYS_ORDERABLE_ARTICLE',
  SET_OWNING_SUPPLIER_ORGANIZATION_ARTICLE:
    'ARTICLE/SET_OWNING_SUPPLIER_ORGANIZATION_ARTICLE',
  HANDLE_PUBLICATIONS_ARTICLE: 'ARTICLE/HANDLE_PUBLICATIONS_ARTICLE',
  PUBLISH_ON_EXACTA_ARTICLE: 'ARTICLE/PUBLISH_ON_EXACTA_ARTICLE',
  DEACTIVATE_ARTICLE: 'ARTICLE/DEACTIVATE_ARTICLE',
  ACTIVATE_ARTICLE: 'ARTICLE/ACTIVATE_ARTICLE',
  MARK_AS_OUT_OF_STOCK_ARTICLE: 'ARTICLE/MARK_AS_OUT_OF_STOCK_ARTICLE',
  MARK_AS_IN_STOCK_ARTICLE: 'ARTICLE/MARK_AS_IN_STOCK_ARTICLE',
  START_CAMPAIGN_ARTICLE: 'ARTICLE/START_CAMPAIGN_ARTICLE',
  END_CAMPAIGN_ARTICLE: 'ARTICLE/END_CAMPAIGN_ARTICLE',
  SET_SUPPLIER_ARTICLE_NUMBER_ARTICLE:
    'ARTICLE/SET_SUPPLIER_ARTICLE_NUMBER_ARTICLE',
  TEST_GUARDED_ACTION_CALL_ARTICLE: 'ARTICLE/TEST_GUARDED_ACTION_CALL_ARTICLE',
  SET_VINDEN_STOCK_QUANTITY_ARTICLE:
    'ARTICLE/SET_VINDEN_STOCK_QUANTITY_ARTICLE',
  SET_BATCH_QUANTITY_ARTICLE: 'ARTICLE/SET_BATCH_QUANTITY_ARTICLE',
  UPDATE_STOCK_QUANTITIES_ARTICLE: 'ARTICLE/UPDATE_STOCK_QUANTITIES_ARTICLE',
  UPDATE_EXACTA_STOCK_QUANTITIES_ARTICLE:
    'ARTICLE/UPDATE_EXACTA_STOCK_QUANTITIES_ARTICLE',
  ENSURE_INVARIANTS_ARTICLE: 'ARTICLE/ENSURE_INVARIANTS_ARTICLE',
  BLOCK_BATCH_ARTICLE: 'ARTICLE/BLOCK_BATCH_ARTICLE',
  UNBLOCK_BATCH_ARTICLE: 'ARTICLE/UNBLOCK_BATCH_ARTICLE',
  BLOCK_BATCHES_ON_ORDER_FULLFILLMENT_CENTER_ARTICLE:
    'ARTICLE/BLOCK_BATCHES_ON_ORDER_FULLFILLMENT_CENTER_ARTICLE',
  UNBLOCK_BATCHES_ON_ORDER_FULLFILLMENT_CENTER_ARTICLE:
    'ARTICLE/UNBLOCK_BATCHES_ON_ORDER_FULLFILLMENT_CENTER_ARTICLE',
  BLOCK_ALL_BATCHES_ARTICLE: 'ARTICLE/BLOCK_ALL_BATCHES_ARTICLE',
  UNBLOCK_ALL_BATCHES_ARTICLE: 'ARTICLE/UNBLOCK_ALL_BATCHES_ARTICLE',
  UPDATE_FROM_EXTERNAL_SOURCE_ARTICLE:
    'ARTICLE/UPDATE_FROM_EXTERNAL_SOURCE_ARTICLE',
  WRITE_ARTICLE_ARTICLE: 'ARTICLE/WRITE_ARTICLE_ARTICLE',
  IMPORT_ARTICLE_ARTICLE: 'ARTICLE/IMPORT_ARTICLE_ARTICLE',
  ADD_FLAIVY_IMAGES_ARTICLE: 'ARTICLE/ADD_FLAIVY_IMAGES_ARTICLE',
  UPDATE_STOCK_KEEPING_UNITS_ARTICLE:
    'ARTICLE/UPDATE_STOCK_KEEPING_UNITS_ARTICLE',
  FORTNOX_ARTICLE_ARTICLE: 'ARTICLE/FORTNOX_ARTICLE_ARTICLE',
  EDIT_ARTICLE_BATCHES_ARTICLE: 'ARTICLE/EDIT_ARTICLE_BATCHES_ARTICLE',
  UPDATE_STOCK_QUANTITIES_MANUALLY_ARTICLE:
    'ARTICLE/UPDATE_STOCK_QUANTITIES_MANUALLY_ARTICLE',
  PRIVAB_IMPORT_ARTICLE_ARTICLE: 'ARTICLE/PRIVAB_IMPORT_ARTICLE_ARTICLE',
  ENSURE_ARTICLE_BATCHES_FOR_OFC_ARTICLE:
    'ARTICLE/ENSURE_ARTICLE_BATCHES_FOR_OFC_ARTICLE',
  ADD_LABEL_ARTICLE: 'ARTICLE/ADD_LABEL_ARTICLE',
  REMOVE_LABEL_ARTICLE: 'ARTICLE/REMOVE_LABEL_ARTICLE',
  UPSERT_ARTICLE: 'ARTICLE/UPSERT_ARTICLE',
  UPSERT_WHEN_EMPTY_ARTICLE: 'ARTICLE/UPSERT_WHEN_EMPTY_ARTICLE',
  UPDATE_WHEN_EMPTY_ARTICLE: 'ARTICLE/UPDATE_WHEN_EMPTY_ARTICLE',
  UPDATE_ARTICLE: 'ARTICLE/UPDATE_ARTICLE',
  FETCH_ARTICLE: 'ARTICLE/FETCH_ARTICLE',
  SET_ARTICLE_LIST: 'SET_ARTICLE_LIST',
  SET_ARTICLE_QUERY: 'ARTICLE/SET_ARTICLE_QUERY',
};

let cancelTokenSource = null;

export const setQuery = query => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.SET_ARTICLE_QUERY,
    payload: { query },
  });
};

export async function fetchMoreAndReturnNewState(newQuery, state, req) {
  const { entities, currentPage, hasMore, sort } = state;

  if (cancelTokenSource) {
    cancelTokenSource.cancel();
  }

  const page = currentPage + 1;

  if (!hasMore && page !== 1) return state;

  cancelTokenSource = axios.CancelToken.source();
  const query = { query: newQuery, page, sort, searchString: state.search };
  const options = { cancelToken: cancelTokenSource.token };
  const responseData = await datalayer.article.list(query, req, options);
  if (responseData === undefined) {
    //canceled request
    return undefined;
  }

  cancelTokenSource = null;
  const recievedEntities = responseData.rows;
  const newHasMore = responseData.page < responseData.totalPages;
  let newEntities = [];
  if (responseData.page === 1) {
    newEntities = recievedEntities;
  } else {
    newEntities = arrayMerge(recievedEntities, entities);
  }
  return {
    query: newQuery,
    hasMore: newHasMore,
    total: responseData.total,
    entities: newEntities,
    currentPage: responseData.page,
    search: state.search,
    sort: _.get(newQuery, 'sort', sort),
  };
}

export const refreshListOnQueryDiff =
  (newListState, req) => async (dispatch, getState) => {
    let payload = newListState;
    const currentState = _.get(getState(), 'articleList');
    const currentQuery = currentState.query;
    if (!_.isEqual(newListState.query, currentQuery)) {
      payload = await fetchMoreAndReturnNewState(
        newListState.query,
        { ...currentState, ...newListState, currentPage: 0 },
        req,
      );
    }
    if (!payload) {
      return;
    } // cancelled loading, dont update the store
    await dispatch({
      type: ACTION_TYPES.SET_ARTICLE_LIST,
      payload,
    });
  };

export const setSortOrder = sort => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.SET_ARTICLE_LIST,
    payload: { sort },
  });
};

export const setListStore = newListState => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.SET_ARTICLE_LIST,
    payload: newListState,
  });
};

export const resolve = async (id, req) => {
  return await datalayer.article.get({ id }, req);
};

export const get = (req, id) => dispatch => {
  return dispatch({
    type: ACTION_TYPES.FETCH_ARTICLE,
    payload: datalayer.article.get({ id }, req),
  });
};

export const makeAllBatchesAlwaysOrderable = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.makeAllBatchesAlwaysOrderable',
  });

export const setOwningSupplierOrganization = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.setOwningSupplierOrganization',
  });

export const handlePublications = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.handlePublications',
  });

export const publishOnExacta = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.publishOnExacta',
  });

export const deactivate = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.deactivate',
  });

export const activate = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.activate',
  });

export const markAsOutOfStock = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.markAsOutOfStock',
  });

export const markAsInStock = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.markAsInStock',
  });

export const startCampaign = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.startCampaign',
  });

export const endCampaign = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.endCampaign',
  });

export const setSupplierArticleNumber = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.setSupplierArticleNumber',
  });

export const testGuardedActionCall = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.testGuardedActionCall',
  });

export const setVindenStockQuantity = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.setVindenStockQuantity',
  });

export const setBatchQuantity = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.setBatchQuantity',
  });

export const updateStockQuantities = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.updateStockQuantities',
  });

export const updateExactaStockQuantities = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.updateExactaStockQuantities',
  });

export const ensureInvariants = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.ensureInvariants',
  });

export const blockBatch = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.blockBatch',
  });

export const unblockBatch = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.unblockBatch',
  });

export const blockBatchesOnOrderFullfillmentCenter = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.blockBatchesOnOrderFullfillmentCenter',
  });

export const unblockBatchesOnOrderFullfillmentCenter = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.unblockBatchesOnOrderFullfillmentCenter',
  });

export const blockAllBatches = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.blockAllBatches',
  });

export const unblockAllBatches = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.unblockAllBatches',
  });

export const updateFromExternalSource = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.updateFromExternalSource',
  });

export const writeArticle = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.writeArticle',
  });

export const importArticle = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.importArticle',
  });

export const addFlaivyImages = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.addFlaivyImages',
  });

export const updateStockKeepingUnits = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.updateStockKeepingUnits',
  });

export const fortnoxArticle = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.fortnoxArticle',
  });

export const editArticleBatches = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.editArticleBatches',
  });

export const updateStockQuantitiesManually = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.updateStockQuantitiesManually',
  });

export const privabImportArticle = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.privabImportArticle',
  });

export const ensureArticleBatchesForOfc = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.ensureArticleBatchesForOfc',
  });

export const addLabel = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.addLabel',
  });

export const removeLabel = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.removeLabel',
  });

export const upsert = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.upsert',
  });

export const upsertWhenEmpty = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.upsertWhenEmpty',
  });

export const updateWhenEmpty = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.updateWhenEmpty',
  });

export const update = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.article.update',
  });
